import React from 'react';
import {
  Flex,
  Icon,
  Text,
  Link,
  FlexProps,
  IconProps,
  TextProps,
} from '@chakra-ui/react';
import { AiStar, ExternalLink } from '@/assets/icons/interview';

interface CustomLinkButtonProps {
  interviewId?: string;
  icon?: React.ComponentType<IconProps>;
  text?: string;
  linkIcon?: React.ComponentType<IconProps>;
  onClick?: () => void;
  styles?: FlexProps;
  textStyles?: TextProps;
  iconStyles?: IconProps;
  linkIconStyles?: IconProps;
  secondIcon?: boolean;
  isDisabled?: boolean;
  showPrimaryIcon?: boolean;
}

export const AiButton = ({
  icon = AiStar,
  text = 'View AI notetaker',
  linkIcon = ExternalLink,
  onClick,
  styles = {},
  textStyles = {},
  iconStyles = {},

  linkIconStyles = {},
  secondIcon = true,
  isDisabled = false,
  showPrimaryIcon = true,
}: CustomLinkButtonProps) => {
  return (
    <Flex
      gap="4px"
      justifyContent="start"
      alignItems="center"
      borderRadius="xs"
      p="2px 8px"
      borderColor="border-color"
      boxShadow="0px 0px 0px 0px #1018280D"
      border="1px solid transparent"
      bg="linear-gradient( #fff, #fff) padding-box,linear-gradient(180deg, #8A90FF 0%, #B15FDA 100%)"
      onClick={isDisabled ? undefined : onClick}
      opacity={isDisabled ? 0.5 : 1}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      {...styles}
    >
      {showPrimaryIcon && <Icon as={icon} w="16px" h="16px" {...iconStyles} />}

      <Text
        bgGradient="linear(to-b, #8A90FF, #B15FDA)"
        bgClip="text"
        size="sm-semi-bold"
        {...textStyles}
      >
        {text}
      </Text>
      {secondIcon && (
        <Link>
          <Icon
            as={linkIcon}
            color="#8A90FF"
            h="16px"
            mt="6px"
            w="16px"
            {...linkIconStyles}
          />
        </Link>
      )}
    </Flex>
  );
};
